import { computeWithHaversine } from './haversine/haversine';
import { fetchOpenRouteServiceApiToGetDistance } from './road/openrouteservice-api';

export type DistanceCalculationOptions = {
  type: 'road' | 'haversine' | 'road-with-haversine-fallback';
};

export async function calculateDistanceBetweenCoordinates(
  from: [number, number] | undefined,
  to: [number, number] | undefined,
  options: DistanceCalculationOptions = {
    type: 'road-with-haversine-fallback',
  },
) {
  if (
    from === undefined ||
    to === undefined ||
    from[0] === undefined ||
    from[1] === undefined ||
    to[0] === undefined ||
    to[1] === undefined
  ) {
    return 0;
  }

  const start = { lat: from[1], lon: from[0] };
  const end = { lat: to[1], lon: to[0] };

  switch (options.type) {
    case 'road':
      return calculateRoad(start, end);
    case 'haversine':
      return calculateHaversine(start, end);
    case 'road-with-haversine-fallback':
      return calculateRoadWithHaversineFallback(start, end);
    default:
      throw new Error('Unknown distance calculation type');
  }
}

type Coordinates = { lat: number; lon: number };

async function calculateRoad(
  start: Coordinates,
  end: Coordinates,
): Promise<number> {
  return fetchOpenRouteServiceApiToGetDistance(start, end);
}

function calculateHaversine(start: Coordinates, end: Coordinates): number {
  return computeWithHaversine(start, end);
}

async function calculateRoadWithHaversineFallback(
  start: Coordinates,
  end: Coordinates,
): Promise<number> {
  let distance = await fetchOpenRouteServiceApiToGetDistance(start, end);
  if (distance === 0) {
    distance = computeWithHaversine(start, end);
  }
  return distance;
}
